import request from "@/utils/request";
export default {
  // 分页查询
  getAuditorData: (param) => {
    return request({
      url: `/rmc/produce/auditor/list`,
      method: "post",
      data: param,
    });
  },
  // 农场明细
  getAuditorDetail: (rmcProduceAuditorId) => {
    return request({
      url: `/rmc/produce/auditor/detail/${rmcProduceAuditorId}`,
      method: "post",
      data: {},
    });
  },
  // 获取sponsor
  getSponsorByUser: () => {
    return request({
      url: `/rmc/protein/medicine/getSponsorByUser`,
      method: "post",
      data: {},
    });
  },
  // 新增
  addAuditor: (param) => {
    return request({
      url: `/rmc/produce/auditor/create`,
      method: "post",
      data: param,
    });
  },
  // 更新
  updateAuditor: (rmcProduceAuditorId, param) => {
    return request({
      url: `/rmc/produce/auditor/update/${rmcProduceAuditorId}`,
      method: "post",
      data: param,
    });
  },
  // 提交
  submitAuditor: (rmcProduceAuditorId, param) => {
    return request({
      url: `/rmc/produce/auditor/submit/${rmcProduceAuditorId}`,
      method: "post",
      data: param,
    });
  },
  // 批量提交
  submitBtach: (param) => {
    return request({
      url: `/rmc/produce/auditor/submit`,
      method: "post",
      data: param,
    });
  },
  // Farm退回
  returnAuditor: (param) => {
    return request({
      url: `/rmc/produce/auditor/return`,
      method: "post",
      data: param,
    });
  },
  // Farm批准
  approveAuditor: (param) => {
    return request({
      url: `/rmc/produce/auditor/approve`,
      method: "post",
      data: param,
    });
  },
  // Farm删除
  deleteAuditor: (param) => {
    return request({
      url: `/rmc/produce/auditor/delete`,
      method: "post",
      data: param,
    });
  },
  // Farm确认无更新
  confirmNoChange: (param) => {
    return request({
      url: `/rmc/produce/auditor/confirmNoChange`,
      method: "post",
      data: param,
    });
  },
  // 更新日志列表
  updateLog: (param) => {
    return request({
      url: `/rmc/produce/auditor/updateLog`,
      method: "post",
      data: param,
    });
  },
  // 导出审核员清单
  downloadAuditorLists: (param) => {
    return request({
      url: `/rmc/produce/auditor/downloadAuditorList`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  // 导出季度审核员清单
  downloadAuditorQuarterList: (param) => {
    return request({
      url: `/rmc/produce/auditor/downloadAuditorQuarterList`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  // 导出更新日志
  downloadUpdateLogList: (param) => {
    return request({
      url: `/rmc/produce/auditor/downloadUpdateLogList`,
      data: param,
      method: "post",
      responseType: "blob",
      fullResponse: true,
    });
  },
  // 查询ASL Group
  getAslGroupList: (sponsor) => {
    return request({
      url: `/rmc/protein/asl/aslGroupList?sponsor=${sponsor}`,
      method: "post",
      data: {},
    });
  },
  // 下拉框列表
  getSelection: (param) => {
    return request({
      url: `/downloadList`,
      method: "post",
      data: param,
    });
  },
  // 查询Farm Group
  getFarmGroupList: (sponsor) => {
    return request({
      url: `/rmc/produce/farmGroup/farmGroupList?sponsor=${sponsor}`,
      method: "post",
      data: {},
    });
  },
  // 获取授权的Category3
  getAuthorizedCategory3: () => {
    return request({
      url: `/rmc/protein/farm/authorizedCategory3`,
      method: "get",
    });
  },
};
